import { useTranslationContext } from '@interhyp/util-translation';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getTranslation } from '../redux/MandantConfig/selectors';

// TODO: Remove old useTranslationContext when the migration is over
export function useWatchTranslations(): void {
  const { addTranslation } = useTranslationContext();
  const data = useSelector(getTranslation);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      addTranslation(data);
    }
  }, [addTranslation, data]);
}
